import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { useScrollCarousel } from 'dibs-scroll-carousel/exports/ScrollCarouselContext';

import styles from './Counter.scss';

export const Counter: FC = () => {
    const { activeSlide, totalSlides } = useScrollCarousel();

    return (
        <div className={styles.counter} data-tn="pdp-image-carousel-counter">
            <FormattedMessage
                id="Counter"
                defaultMessage="{activeSlide} of {totalSlides}"
                values={{ activeSlide, totalSlides }}
            />
        </div>
    );
};
